module.exports = __webpack_public_path__ + "static/media/mainTopicAc.27a6e5d9.svg";